import React, { useCallback, useEffect, useState } from "react";
import { languageHelper } from "../../../config/helperFunctions";
import { toast } from "react-toastify";
import axios from "axios";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";

function RenewProductionKey() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [otp, setOtp] = useState("");
  const [data, setData] = useState({
    csr_content: ``,
    private_key: ``,
    requestID: ``,
    binarySecurityToken: ``,
    secret: ``,
  });

  const copyToClipboard = (item) => {
    navigator.clipboard
      .writeText(item)
      .then(() => {
        toast.info(languageHelper("Copied to clipboard!"));
      })
      .catch(() => {
        toast.error(languageHelper("Failed to copy!"));
      });
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(
        `${apiKey}/api/rms/admin/zatca/get-key`,
        {
          common_name: data?.common_name,
          otp: otp,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success(
          res.data.api_response || "Production key retrieved successfully"
        );
        getData();
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message || "Failed to retrieve production key"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getProdKey = () => {
    setLoading(true);
    axios
      .post(
        `${apiKey}/api/rms/admin/zatca/renew-key`,
        {
          otp,
          common_name: data?.common_name,
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        toast.success(
          res.data.api_response || "Production key retrieved successfully"
        );
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message || "Failed to retrieve production key"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/zatca/csr`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        setError(err.response?.data?.message || "Failed to fetch CSR data");
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token]);

  useEffect(() => {
    getData();
  }, [getData]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-d-bg-text text-2xl">
            {languageHelper("Zatca Configuration")}
          </h1>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleOtpSubmit}>
            <div className="md:grid grid-cols-2 gap-x-4">
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("OTP")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="uid"
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder={"123456"}
                    value={otp}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit")}
              </button>
            </div>
          </form>
          <form action="" className="w-full mt-4">
            <div className="md:grid grid-cols-2 gap-x-4">
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative font-bold">
                  {languageHelper("CSR Content")}
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    name="uid"
                    onChange={() => {}}
                    value={data.csr_content}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-gray-100 rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full cursor-not-allowed"
                    id="autocomplete"
                    rows={5}
                    required
                    readOnly
                  />
                </div>
                <button
                  type="button"
                  onClick={() => copyToClipboard(data?.csr_content)}
                  className="text-xs border bg-gray-50 p-1 rounded"
                >
                  {languageHelper("Copy Full CSR")}
                </button>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative font-bold">
                  {languageHelper("Private Key")}
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    name="uid"
                    onChange={() => {}}
                    value={data.private_key}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-gray-100 rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full cursor-not-allowed"
                    id="autocomplete"
                    rows={5}
                    required
                    readOnly
                  />
                </div>
                <button
                  type="button"
                  onClick={() => copyToClipboard(data?.private_key)}
                  className="text-xs border bg-gray-50 p-1 rounded"
                >
                  {languageHelper("Copy Private Key")}
                </button>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative font-bold">
                  {languageHelper("Request ID")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="uid"
                    onChange={() => {}}
                    value={data.requestID}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-gray-100 rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full cursor-not-allowed"
                    id="autocomplete"
                    required
                    readOnly
                  />
                </div>
                <button
                  type="button"
                  onClick={() => copyToClipboard(data?.requestID)}
                  className="text-xs border bg-gray-50 p-1 rounded"
                >
                  {languageHelper("Copy Request ID")}
                </button>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative font-bold">
                  {languageHelper("Binary Token")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="uid"
                    onChange={() => {}}
                    value={data.binarySecurityToken}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-gray-100 rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full cursor-not-allowed"
                    id="autocomplete"
                    required
                    readOnly
                  />
                </div>
                <button
                  type="button"
                  onClick={() => copyToClipboard(data?.binarySecurityToken)}
                  className="text-xs border bg-gray-50 p-1 rounded"
                >
                  {languageHelper("Copy Binary Token")}
                </button>
              </label>
              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative font-bold">
                  {languageHelper("Secret Key")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    name="uid"
                    onChange={() => {}}
                    value={data.secret}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-gray-100 rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full cursor-not-allowed"
                    id="autocomplete"
                    required
                    readOnly
                  />
                </div>
                <button
                  type="button"
                  onClick={() => copyToClipboard(data?.secret)}
                  className="text-xs border bg-gray-50 p-1 rounded"
                >
                  {languageHelper("Copy Secret Key")}
                </button>
              </label>
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="button"
                onClick={getProdKey}
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Get Production Key")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default RenewProductionKey;
